import "./Products.module.css";
import Header from "@/reusable_sections/Header";
import TechnologyHero from "./sections/TechnologyHero";
import Partners from "./sections/Partners";
import Footer from "@/reusable_sections/Footer";
export default function ProductsPage() {
  return <div>
      <Header />
      <TechnologyHero />
      <Partners />
      <Footer />
    </div>;
}